import CryptoJS from 'crypto-js';
const key="client"
const valuekey = "1za86tkhzq2hgq9i1mfywqaqirokdt4e"


function set(value){
    if(!value) return; 

    try{
        let phone = value.phone; 
        if(phone){
            phone = CryptoJS.AES.encrypt(phone,valuekey).toString();
        }
        const client = {
            id: value.id,
            name:value.name,
            phone:phone,
            counter:value.counter,  
        }
        const jsonClient = JSON.stringify(client); 
        localStorage.setItem(key,jsonClient);
    }catch(error){
        console.error(error);
    } 
}

function get() {
    let client;

    try{
       const jsonClient = localStorage.getItem(key); 
       if(!jsonClient) return null;
       client =  JSON.parse(jsonClient);

        if(client && client.phone){
            const decrypted = CryptoJS.AES.decrypt(client.phone, valuekey);
            client.phone = decrypted.toString(CryptoJS.enc.Utf8)
        }
    }catch(error){
        console.error(error);
        return null; 
    }

    return client; 
}

function remove(){  
    localStorage.setItem(key,""); 
}



const clientInfosource = {
    set: set,
    get: get,
    remove: remove,
  }; 

export {
    clientInfosource
}


